module.exports = __webpack_public_path__ + "assets/img/video.b03e52a6.svg";